<template>
  <v-container>
    <v-row v-if="taskInfo.finish">
      <v-alert
          dense
          border="left"
          :type="taskInfo.profit < 0 ? 'warning' : 'success'"
          colored-border
      >
        {{successMessage}}
      </v-alert>
    </v-row>
    <v-row>
      <v-col md="12" sm="3" class="dashboard-button">
        <v-btn outlined color="primary" @click="editTask">{{$t('book/issue:task-edit')}}</v-btn>
        <v-btn outlined color="primary" v-if="couldTaskBeProcessed" :disabled="isOrderSend" @click="startTask">{{$t('book/issue:send-task')}}</v-btn>
        <v-btn outlined color="primary" :disabled="isTaskFinished || orderFinished" @click="finishTask">{{$t('book/issue:finish-task')}}</v-btn>
        <ReasonButton ref="reasonButton" :disabled="isTaskFinished || orderFinished" @cancelTask="v => cancelTask(v)"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-timeline dense class="pt-0">
          <div class="my-scroller">
            <v-timeline-item v-for="item in statuses" :key="item.id" class="mr-5">
              <template v-slot:icon>
                <v-avatar title color="blue">
                  <v-icon dark>
                    {{ eventLogHelper.findIcon(item.action) }}
                  </v-icon>
                </v-avatar>
              </template>
              <v-card class="elevation-3">
                <v-card-subtitle :class="'d-flex justify-space-between' ">
                  <div>
                    <p class="mb-0">{{ parseDate(item.createdAt) }}</p>
                  </div>
                </v-card-subtitle>
                <v-card-text>
                  <p v-html="generateText(item)"></p>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </div>
        </v-timeline>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AddTaskDialog
          @closeDialog="$emit('callUpdateData')"
          :read-only="isTaskFinished || orderFinished || isOrderSend"
          ref="taskDialog" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import ReasonButton from '@/modules/book/views/task/dialog-components/general-tab/ReasonButton.vue';
import TaskBoardService from '@/modules/book/services/task-board-service';
import AddTaskDialog from '@/modules/book/views/task/AddTaskDialog.vue';
import EventLogHelper from '@/modules/book/data/eventLogHelper';
import DateUtils from '@/modules/core/services/date-utils';
import Utils from '@/modules/core/services/utils';

export default {
  name: 'GeneralTab',
  components: {ReasonButton, AddTaskDialog},
  props: {
    taskInfo: {},
    taskStatus: {},
    couldTaskBeProcessed: Boolean,
    isTaskFinished: Boolean
  },
  data() {
    return {
      statuses: [],
      orderSent: false,
      orderFinished: false,
      contractInfo: {},
      eventLogHelper: null,
    }
  },
  watch: {
    taskInfo() {
      this.statuses = [];
      this.updateStatuses();
    }
  },
  computed: {
    isOrderSend() {
      return this.taskStatus && this.taskStatus.CREATE_ORDER || this.orderSent;
    },
    successMessage() {
      let message = this.$t('book/issue:common.finish-message');

      if (this.taskInfo.profit === 0) {
        message += ' ' + this.$t('book/issue:common.budget-successful-message');
      } else if (this.taskInfo.profit > 0) {
        message +=
            ' ' + this.$t('book/issue:common.saved-budget-message', {budget: this.taskInfo.profit, currency: 'Euro'});
      } else  {
        message +=
            ' ' + this.$t('book/issue:common.budget-overrun-message', {budget: this.taskInfo.profit, currency: 'Euro'});
      }

      return message;
    }
  },
  methods: {
    editTask() {
      this.$refs.taskDialog.openDialog(this.taskInfo);
    },
    generateText(status) {
      let result = '';

      switch (status.action) {
        case 'OFFER_SIGN':
          result = this.$t('book/issue:status.OFFER_IS_SELECTED', {id: status.objectId});
          break;
        case 'INVOICE_SIGN':
          result = this.$t('book/issue:status.INVOICE_IS_SIGNED', {id: status.objectId});
          break;
        case 'INVOICE_SEND':
          result = this.$t('book/issue:status.INVOICE_IS_SENT', {id: status.objectId});
          break;
        case 'CREATE_ORDER':
          result = this.$t('book/issue:status.ORDER_IS_CREATED');
          break;
        case 'FINISH_ORDER':
          result = this.$t('book/issue:status.ORDER_IS_FINISHED');
          break;
        case 'SUCCESS_TASK':
          result = this.$t('book/issue:status.TASK_IS_FINISHED');
          break;
        case 'FAIL_TASK':
          result = this.$t('book/issue:status.TASK_IS_FAIL', {reason: this.$t('book/issue:reasons.' + status.description)});
          break;
        case 'INVOICE_ADD':
          result = this.$t('book/issue:status.INVOICE_ADD', {id: status.objectId});
          break;
        case 'OFFER_ADD':
          result = this.$t('book/issue:status.OFFER_ADD', {id: status.objectId});
          break;
        case 'TASK_DOC_ADD':
          result = this.$t('book/issue:status.TASK_DOC_ADD', {id: status.objectId});
          break;
        case 'OFFER_REMOVE':
          result = this.$t('book/issue:status.OFFER_REMOVE', {id: status.objectId});
          break;
        case 'INVOICE_REMOVE':
          result = this.$t('book/issue:status.INVOICE_REMOVE', {id: status.objectId});
          break;
        case 'TASK_DOC_REMOVE':
          result = this.$t('book/issue:status.TASK_DOC_REMOVE', {id: status.objectId});
          break;
      }

      return result;
    },
    updateStatuses() {
      if (!this.taskInfo || !this.taskInfo.taskStatus || this.taskInfo.taskStatus.length === 0) {
        return;
      }

      let statuses = this.taskInfo.taskStatus;
      statuses.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      this.statuses = statuses;
    },
    startTask() {
      if (!this.taskInfo || !this.taskInfo.id) {
        return;
      }

      TaskBoardService.startTask(
          this.taskInfo.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:update-success', {name: this.$t('book/issue:common.task')}));
            this.orderSent = true;
            this.$emit('callUpdateData');
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:update-failure', {name: this.$t('book/issue:common.task')}));
          }
      );
    },
    finishTask() {
      if (!this.taskInfo || !this.taskInfo.id) {
        return;
      }

      TaskBoardService.finishTask(
          this.taskInfo.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:update-success', {name: this.$t('book/issue:common.task')}));
            this.orderFinished = true;
            this.$emit('callUpdateData');
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:update-failure', {name: this.$t('book/issue:common.task')}));
          }
      );
    },
    parseDate(value) {
      return DateUtils.parseDateTimeForDisplay(value);
    },
    clearData() {
      this.orderFinished = false;
    },
    cancelTask(reason) {
      TaskBoardService.cancelTask(
          this.taskInfo.id,
          reason,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:update-success', {name: this.$t('book/issue:common.task')}));
            this.orderFinished = true;
            this.$emit('callUpdateData');
            this.$refs.reasonButton.close();
          }
      )
    }
  },
  created() {
    this.eventLogHelper = new EventLogHelper();
  },
}
</script>

<style lang="scss">
  button.v-btn {
    margin-right: 10px;
    margin-bottom:  10px;
  }
</style>